import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { usePollInputErrors } from '../utils/use-poll-option-errors';
import { PollDataContext } from './poll-data-context';
export const PollDataContextWrapper = ({ children, openDays, options, question, }) => {
    const { pollInputErrors, togglePollInputError, hasInputErrors } = usePollInputErrors();
    const [pollData, setPollData] = React.useState({
        openDays,
        options,
        question,
    });
    const replaceOptionText = (text, index) => {
        const newOptions = [...pollData.options];
        newOptions[index] = { ...newOptions[index], text };
        setPollData({ ...pollData, options: newOptions });
    };
    const normalizedPollData = {
        ...pollData,
        options: pollData.options.filter(({ text }) => text.trim()),
    };
    return (_jsx(PollDataContext.Provider, { value: {
            ...{ pollData, setPollData },
            ...{ normalizedPollData, replaceOptionText },
            ...{ hasInputErrors, pollInputErrors, togglePollInputError },
        }, children: children }));
};
//# sourceMappingURL=poll-data-context-wrapper.js.map